import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip, IconButton } from '@material-ui/core';
import ClearAll from '@material-ui/icons/ClearAll';
// import { Container } from './styles';

export default function ResetTable({ handleClick }) {
  return (
    <Tooltip title="Resetar tabela">
      <IconButton onClick={handleClick}>
        <ClearAll />
      </IconButton>
    </Tooltip>
  );
}

ResetTable.propTypes = {
  handleClick: PropTypes.func.isRequired,
};
